const hasHealthSubscription = (subscriptions) => {
    if (!subscriptions)
        return false
    if (subscriptions.includes("SANTE"))
        return true
    return false
}

export default hasHealthSubscription
